var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetsIconsGamepadLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lets-icons:gamepad-light"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.75 43.75C43.75 42.1392 42.4441 40.8333 40.8333 40.8333C39.2225 40.8333 37.9166 42.1392 37.9166 43.75C37.9166 45.3608 39.2225 46.6667 40.8333 46.6667C42.4441 46.6667 43.75 45.3608 43.75 43.75Z",
    fill: "#4555BA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.1667 40.8333H17.5M23.3333 35V46.6667",
    stroke: "#4555BA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M52.5 37.9167C52.5 36.3058 51.1941 35 49.5833 35C47.9725 35 46.6666 36.3058 46.6666 37.9167C46.6666 39.5275 47.9725 40.8333 49.5833 40.8333C51.1941 40.8333 52.5 39.5275 52.5 37.9167Z",
    fill: "#4555BA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M40.8333 23.3333C40.8333 22.1171 40.8333 21.5104 40.7341 20.9738C40.5613 20.0587 40.1719 19.1984 39.5985 18.4647C39.0251 17.7309 38.2844 17.1451 37.4383 16.7563C36.9425 16.5288 36.3533 16.38 35.175 16.0854L35 16.0417C33.6554 15.7063 32.9816 15.5371 32.4245 15.2629C31.6351 14.8744 30.9438 14.3124 30.4023 13.6189C29.8609 12.9254 29.4833 12.1184 29.2979 11.2583C29.1666 10.6517 29.1666 9.9575 29.1666 8.56917V5.83334",
    stroke: "#4555BA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.75 40.8333C8.75 33.3696 8.75 29.6392 10.5583 27.0667C11.025 26.4075 11.5675 25.8125 12.1742 25.305C14.5308 23.3333 17.9492 23.3333 24.7917 23.3333H45.2083C52.0508 23.3333 55.4692 23.3333 57.8258 25.305C58.4325 25.8125 58.9779 26.4075 59.4417 27.0667C61.25 29.6392 61.25 33.3696 61.25 40.8333C61.25 48.2971 61.25 52.0275 59.4417 54.6C58.9821 55.2551 58.4389 55.8473 57.8258 56.3617C55.4692 58.3333 52.0508 58.3333 45.2083 58.3333H24.7917C17.9492 58.3333 14.5308 58.3333 12.1742 56.3617C11.5611 55.8473 11.0179 55.2551 10.5583 54.6C8.75 52.0275 8.75 48.2971 8.75 40.8333Z",
    stroke: "#4555BA",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetsIconsGamepadLight);
export default __webpack_public_path__ + "static/media/lets-icons_gamepad-light.af7457d83c75fe556415ced31d9d2a64.svg";
export { ForwardRef as ReactComponent };